/* ============================================================
   Welk ontwerp hoort bij welk product — TOON atelier
   Bestand: assets/gallery-wall-koppeling.js

   VOORSTEL van 2026-09-11, nog niet door Hannah nagelopen.
   De sleutels zijn Shopify-handles, de waarden verwijzen naar
   gallery-wall-uitsneden.js.

   zeker        de naam van het product zegt het, en de maten kloppen
   waarschijnlijk  past logisch, maar niet hard te controleren
   onbekend     er is nog geen ontwerp voor; het product krijgt voorlopig
                geen uitsnede in de visualizer

   Staat er 'perVariant', dan hangt het ontwerp af van een productoptie.
   ============================================================ */

(function (root) {
  'use strict';

  var KOPPELING = {

    /* ---- organische vormen: naam spreekt voor zich ---- */
    'wolk-vorm-organisch-passe-partout':
      { ontwerp: 'wolk', zeker: 'zeker' },
    'asymmetrisch-rond-organische-vorm-passe-partout':
      { ontwerp: 'asymmetrischRond', zeker: 'zeker' },
    'golvend-frame-organische-vorm-passe-partout':
      { ontwerp: 'golvendFrame', zeker: 'zeker' },
    'ronde-hoeken-frame-organische-vorm-passe-partout':
      { ontwerp: 'rondeHoekenFrame', zeker: 'zeker' },
    'balans-organische-vorm-passe-partout':
      { ontwerp: 'balans', zeker: 'zeker' },

    /* ---- polaroids ---- */
    'polaroid-mini-passe-partout':
      { ontwerp: 'polaroidMini', zeker: 'zeker' },
    '21x30-cm-polaroid-mini-passe-partout':
      { ontwerp: 'polaroidMiniHoek', zeker: 'zeker',
        opmerking: 'in de hoek, alleen A4 (Hannah, 15 okt 2026)' },
    'schuine-polaroid-mini-passe-partout':
      { ontwerp: 'polaroidMiniSchuin', zeker: 'zeker' },
    '2x-mini-polaroid-off-center-passe-partout':
      { ontwerp: 'polaroidMini2', zeker: 'zeker' },
    'polaroid-sqaure-passe-partout':
      { ontwerp: 'polaroidSquare', zeker: 'zeker' },
    '30x40-cm-polaroid-square-passe-partout':
      { ontwerp: 'polaroidSquareHoek', zeker: 'zeker',
        opmerking: 'in de hoek, alleen 30x40 (Hannah, 15 okt 2026)' },
    'schuine-polaroid-sqaure-passe-parout':
      { ontwerp: 'polaroidSquareSchuin', zeker: 'zeker' },
    'polaroid-wide-passe-partout':
      { ontwerp: 'polaroidWide', zeker: 'zeker' },
    '12x-polaroid-passe-partout':
      { optie: 'Binnenformaat', perVariant: {
          'Polaroid mini': 'polaroid12mini',
          'Polaroid square': 'polaroid12square'
        }, zeker: 'zeker' },
    // De bundel blijft buiten de visualizer, op verzoek van Hannah.
    'ronde-hoeken-polaroid-instax-mini-passe-partout':
      { optie: 'Binnenformaat', perVariant: {
          'Polaroid mini': 'polaroidMiniRondeHoeken',
          'Polaroid square': 'polaroidSquareRondeHoeken',
          'Polaroid wide': 'polaroidWideRondeHoeken'
        }, zeker: 'zeker',
        opmerking: 'zelfde ronde hoeken, elk op zijn eigen maat' },

    /* ---- foto en kioskfoto ---- */
    'fotostrip-kioskfoto-passe-partout':
      { optie: 'Binnenformaat', perVariant: {
          '5x15 cm': 'kioskfoto',
          '4x20 cm': 'kioskfoto4x20'
        }, zeker: 'zeker' },
    '30x40-cm-fotostrip-passe-partout-1':
      { optie: 'Binnenformaat', perVariant: {
          '5x15 cm': 'kioskfotoHoek',
          '4x20 cm': 'kioskfotoHoek4x20'
        }, zeker: 'zeker',
        opmerking: 'linksonder in de hoek, 4 cm van links en van onder (Hannah, 15 okt 2026)' },
    'ronde-hoeken-standaard-10x15cm-foto-passe-partout':
      { optie: 'Binnenformaat', perVariant: {
          '10x15 cm': 'foto1015RondeHoeken',
          'A6': 'fotoA6RondeHoeken'
        }, zeker: 'zeker' },
    '30x40-cm-foto-standaard-10x15-cm-passe-partout':
      { optie: 'Binnenformaat', perVariant: {
          '10x15 cm': 'foto1015Hoek',
          'A6': 'fotoA6Hoek'
        }, zeker: 'zeker',
        opmerking: 'links onder in de hoek, op 30x40 en op 40x50' },
    '50x70cm-foto-15x20cm-passe-partout':
      { ontwerp: 'foto1520Hoek', zeker: 'zeker',
        opmerking: 'de foto zit in de hoek' },

    /* ---- posters ---- */
    'standaard-poster-formaat-passe-partout':
      { ontwerp: 'poster', zeker: 'zeker' },
    'standaard-poster-formaat-2-passe-partout':
      { ontwerp: 'posterLiggend', zeker: 'zeker' },
    'standaard-poster-formaat-3-passe-partout':
      { ontwerp: 'posterHoog', zeker: 'zeker' },
    '40x50cm-passe-partout-voor-a4-21x29-7cm-poster':
      { ontwerp: 'posterA4Midden', zeker: 'zeker',
        opmerking: 'staand, 20 breed en 28,7 hoog, gecentreerd (Hannah, 15 okt 2026)' },
    '50x70cm-passe-partout-voor-30x40cm-poster':
      { ontwerp: 'poster3040Midden', zeker: 'zeker',
        opmerking: '29 x 39, gecentreerd — zo staat het op de productfoto' },

    /* ---- schuin ---- */
    'schuine-kubus-angled-shape-passe-partout':
      { ontwerp: 'schuineKubus', zeker: 'zeker' },
    'schuine-10x15cm-foto-passe-partout':
      { optie: 'Binnenformaat', perVariant: {
          '10x15 cm': 'foto1015Schuin',
          'A6': 'fotoA6Schuin'
        }, zeker: 'zeker',
        opmerking: '9,5 x 14,5 (A6: 10 x 14,3) op 10 graden, gecentreerd' },

    /* ---- nog geen ontwerp voor ---- */
    'polaroid-instax-wide-x2-in-het-hoekje-passe-partout':
      { ontwerp: 'wideX2Hoek', zeker: 'zeker',
        opmerking: 'twee onder elkaar, rechtsonder in de hoek' },
    'verticale-polaroid-reeks-2-3-4-fotos':
      { optie: 'Binnenformaat', perVariant: {
          'Polaroid mini': 'reeksMini',
          'Polaroid square': 'reeksSquare',
          'Polaroid wide': 'reeksWide'
        }, zeker: 'zeker',
        opmerking: 'het aantal volgt uit het buitenformaat: 2 op 30x40, 3 op 40x50, 4 op 50x70' },
    '2x-foto-strip-kioskfoto-gecentreerd-passe-partout':
      { optie: 'Binnenformaat', perVariant: {
          '5x15 cm': 'kioskfoto2',
          '4x20 cm': 'kioskfoto2x4x20'
        }, zeker: 'zeker',
        opmerking: '2,5 cm vanaf links, verticaal gecentreerd' },
    '50x70cm-2x-15x20cm-foto-liggend-passe-partout':
      { ontwerp: 'foto1520X2Hoek', zeker: 'zeker',
        opmerking: 'twee liggende foto\'s onder elkaar, rechtsonder' }
  };

  // Geeft de ontwerpsleutel voor een product, eventueel afhankelijk van een variant.
  function ontwerpVan(handle, variantTitel) {
    var k = KOPPELING[handle];
    if (!k) return null;
    if (k.perVariant) {
      var titel = String(variantTitel || '');
      var namen = Object.keys(k.perVariant);
      for (var i = 0; i < namen.length; i++) {
        if (titel.indexOf(namen[i]) !== -1) return k.perVariant[namen[i]];
      }
      return null;
    }
    return k.ontwerp || null;
  }

  root.GalleryWallKoppeling = {
    lijst: KOPPELING,
    ontwerpVan: ontwerpVan,
    handles: Object.keys(KOPPELING)
  };
})(window);
